import SmallDetails from "components/SmallDetails/SmallDetails";
import moment from "moment";
import React from "react";
import { formatWrittenDayMonthYear } from "utilities";

interface Props {
  sendDate: moment.Moment;
  lifeCycle: server.dto.DocumentLifeCycles;
  hasProducts: boolean;
}

export const DocumentSendDate = (props: Props) => {
  const sendDate = moment.utc(props.sendDate);
  const today = moment.utc();

  let sublabel: string;
  const isCompletedOrDiscarded = props.lifeCycle === "completed" || props.lifeCycle === "discarded";

  if (isCompletedOrDiscarded && props.hasProducts) {
    sublabel = undefined;
  } else if (sendDate.isAfter(today, "day")) {
    sublabel = sendDate.fromNow();
  } else if (sendDate.isSame(today, "day")) {
    sublabel = RESX.DateTime.Today;
  } else {
    const daysOpen = today.startOf("day").diff(sendDate.startOf("day"), "days");
    if (daysOpen === 1) {
      sublabel = RESX.DateTime.YDayOpen;
    } else {
      sublabel = RESX.DateTime.XDaysOpen.replace("{0}", daysOpen.toString());
    }
  }

  return <SmallDetails
    label={formatWrittenDayMonthYear(props.sendDate)}
    subLabel={sublabel}
  />
}